<template>
  <div>
    <MapContainer :filters="true"/>
  </div>
</template>

<script>
import MapContainer from "../components/Map/MapContainer";
export default {
  name: "CartePage",
  components : {MapContainer}
}
</script>

<style scoped>

</style>